import { render, staticRenderFns } from "./select.vue?vue&type=template&id=204b016b&scoped=true&lang=html"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b016b",
  null
  
)

export default component.exports